import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const ShortLinkRedirectPage = lazy(() => import("./ShortLinkRedirectPage"));
const DownloadAttachmentPage = lazy(() => import("./DownloadAttachmentPage"));

export type CommonPagesNavigationParams = {
  commonShortLinkRedirect: PageNavParams<{ shortLinkId: string }>;
  commonDownloadAttachmentPage: PageNavParams<
    { attachmentId: string },
    { n: string }
  >;
};

export const commonPagesNavigationConfig: ModulePagesConfig<CommonPagesNavigationParams> =
  {
    commonShortLinkRedirect: {
      element: <ShortLinkRedirectPage />,
      path: "/L/:shortLinkId",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
    },
    commonDownloadAttachmentPage: {
      element: <DownloadAttachmentPage />,
      path: "/A/:shortLinkId",
      isPrivate: true,
      isEntityOptional: true,
      isProfileOptional: true,
      isSideBarHidden: true,
    },
  };
